import { stringToDate } from 'modules/core/lib/dates'

import type CopyPeriodForm from 'modules/shift_management/lib/forms/CopyPeriodForm'

export enum CopyTypeEnum {
  schedule = 'schedule',
  coverage = 'coverage',
}

export type CopyType = CopyTypeEnum | undefined

export type WizardData = {
  startDateSchedule: string
  endDateSchedule: string
  daysSchedule: number
  startDateCoverage: string
  endDateCoverage: string
  daysCoverage: number
  destinationStartDate: string
  copyType?: CopyType
}

export type DateValues = [string | undefined, string | undefined]

export const diffTimes = (form: CopyPeriodForm): number => {
  return diffBetweenDateTimes(form.get('start_at').value as string, form.get('end_at').value)
}

export const diffBetweenDateTimes = (start: string, end: string): number => {
  const startDate = stringToDate(start, 'backend')
  const endDate = stringToDate(end, 'backend')

  return endDate.diff(startDate, 'days') + 1
}

export const isValidPeriodOrigin = (daysDiff: number): boolean => {
  return daysDiff <= 90
}
